module.exports = __webpack_public_path__ + "img/exam_jan_2025_yo7uq8wi.22012b00.jpg";